// store/modules/navigation.js
import router from '../../router/index'

export const navigationStore = {
  state: {
    isConfirmModalOpen: false,
    pendingNavigation: null,
  },
  mutations: {
    setConfirmModalOpen(state, isOpen) {
      state.isConfirmModalOpen = isOpen
    },
    setPendingNavigation(state, navigation) {
      state.pendingNavigation = navigation
    },
  },
  getters: {
    isConfirmModalOpen: (state) => {
      return state.isConfirmModalOpen
    },
  },
  actions: {
    showConfirmModal({ commit }, navigation) {
      commit('setConfirmModalOpen', true)
      commit('setPendingNavigation', navigation)
    },
    hideConfirmModal({ commit }) {
      commit('setConfirmModalOpen', false)
      commit('setPendingNavigation', null)
    },
    confirmNavigation({ state, dispatch }) {
      if (state.pendingNavigation) {
        router.push(state.pendingNavigation.to.path)
        // setTimeout is used to prevent concurrency issues with Vue Router
        setTimeout(() => {
          dispatch('hideConfirmModal')
        }, 0)
      }
    },
    cancelNavigation({ state, dispatch }) {
      if (state.pendingNavigation) {
        state.pendingNavigation.next(false)
        dispatch('hideConfirmModal')
      }
    },
  },
}
